import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
interface NavBarProps {
  onBuyClick?: (e: React.MouseEvent) => void;
}
const navLinks = [{
  label: 'Hazlo por ellos',
  href: '#do-it-for-them'
}, {
  label: 'La Solución',
  href: '#solution'
}, {
  label: 'Testimonios',
  href: '#testimonials',
  highlight: true
}, {
  label: 'E-Book Principal/Bonos',
  href: '#product-section'
}];
export function NavBar({
  onBuyClick
}: NavBarProps) {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  useEffect(() => {
    if (menuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [menuOpen]);
  const handleNavClick = (href: string) => {
    setMenuOpen(false);
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <>
      <nav aria-label="Navegación principal" className={`fixed top-[40px] left-0 right-0 z-[9999] flex items-center justify-between px-6 transition-all duration-300 ${scrolled ? 'h-[58px] shadow-md' : 'h-[65px]'}`} style={{
      background: 'rgba(250, 247, 242, 0.95)',
      backdropFilter: 'blur(15px)',
      borderBottom: '1px solid rgba(183, 110, 121, 0.15)'
    }} data-id="element-284">
        {/* Logo */}
        <div className="font-bold tracking-wider" style={{
        fontFamily: 'Georgia, serif',
        fontStyle: 'italic',
        color: '#3D2B1F',
        fontSize: '18px',
        letterSpacing: '1px'
      }} data-id="element-285">
          B.E.BE 365
        </div>

        {/* Desktop Nav Links */}
        <div className="hidden lg:flex items-center gap-5" data-id="element-286">
          {navLinks.map(link => <button key={link.href} onClick={() => handleNavClick(link.href)} className={`bg-transparent border-none cursor-pointer font-sans text-[11px] font-bold uppercase tracking-wider transition-colors duration-300 ${link.highlight ? 'text-[#B76E79] font-extrabold border-b-2 border-[rgba(183,110,121,0.4)] pb-0.5' : 'text-[#6B4C3B] hover:text-[#B76E79]'}`} data-id="element-287">
              {link.label}
            </button>)}
          <button onClick={onBuyClick} className="bg-[#B76E79] text-white font-sans text-[11px] font-extrabold uppercase tracking-wider px-[22px] py-2.5 rounded-full border-none cursor-pointer transition-all duration-300 hover:bg-[#a25d67] hover:shadow-lg" style={{
          boxShadow: '0 4px 12px rgba(183, 110, 121, 0.2)'
        }} data-id="element-288">
            Obtener Protocolo
          </button>
        </div>

        {/* Burger Icon (Mobile) */}
        <button className="flex lg:hidden flex-col items-center justify-center gap-[5px] bg-transparent border-none cursor-pointer p-2" onClick={() => setMenuOpen(!menuOpen)} aria-label={menuOpen ? 'Cerrar menú' : 'Abrir menú'} aria-expanded={menuOpen} data-id="element-289">
          {menuOpen ? <XIcon size={24} color="#B76E79" strokeWidth={2} data-id="element-290" /> : <MenuIcon size={24} color="#B76E79" strokeWidth={2} data-id="element-291" />}
        </button>
      </nav>

      {/* Spacer to prevent content from hiding behind fixed banner + nav */}
      <div aria-hidden="true" className="h-[105px]" data-id="element-292" />

      {/* Mobile Overlay */}
      <div role="dialog" aria-label="Menú de navegación móvil" aria-hidden={!menuOpen} className={`fixed left-0 w-full bg-[#FAF7F2] z-[9998] flex flex-col items-center overflow-hidden transition-all duration-400 ease-in-out ${menuOpen ? 'h-[calc(100vh-105px)] pt-[70px] opacity-100' : 'h-0 pt-0 opacity-0'}`} style={{
      top: '105px'
    }} data-id="element-293">
        {navLinks.map((link, i) => <button key={link.href} onClick={() => handleNavClick(link.href)} className={`bg-transparent border-none cursor-pointer mb-9 transition-all duration-300 ${menuOpen ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'} ${link.highlight ? 'text-[#B76E79]' : 'text-[#3D2B1F]'}`} style={{
        fontFamily: 'Georgia, serif',
        fontSize: '24px',
        fontStyle: 'italic',
        transitionDelay: menuOpen ? `${150 + i * 75}ms` : '0ms'
      }} data-id="element-294">
            {link.label}
          </button>)}
        <button onClick={e => {
        setMenuOpen(false);
        onBuyClick?.(e);
      }} className={`bg-[#B76E79] text-white font-sans text-sm font-extrabold uppercase tracking-widest px-11 py-4 rounded-full border-none cursor-pointer mt-6 transition-all duration-300 hover:bg-[#a25d67] ${menuOpen ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`} style={{
        boxShadow: '0 10px 20px rgba(183, 110, 121, 0.2)',
        transitionDelay: menuOpen ? '450ms' : '0ms'
      }} data-id="element-295">
          Obtener Acceso Ahora
        </button>
      </div>
    </>;
}